"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customType = customType;
function _customType(fields) {
    const data = {
        fields,
        type: 'customType',
    };
    return { data };
}
/**
 * Define a custom type. This type represents an inline, typed JSON object.
 * @see {@link https://docs.amplify.aws/react/build-a-backend/data/data-modeling/add-fields/#specify-a-custom-field-type}
 * @param fields the fields to be added to the custom type
 * @returns a custom type
 * @example
 * a.schema({
 *   Post: a.model({
 *     location: a.customType({
 *       lat: a.float(),
 *       long: a.float(),
 *     }),
 *     content: a.string(),
 *   }),
 * });
 * @example
 * a.schema({
 *   Location: a.customType({
 *       lat: a.float(),
 *       long: a.float(),
 *   }),
 *
 *   Post: a.model({
 *     location: a.ref('Location'),
 *     content: a.string(),
 *   }),
 *
 *   User: a.model({
 *     lastKnownLocation: a.ref('Location'),
 *   }),
 * });
 */
function customType(fields) {
    return _customType(fields);
}
